module.exports = __webpack_public_path__ + "img/sun-rain-snow-01.654b7277.png";